module.exports = __webpack_public_path__ + "img/page2_left.5585a702.jpg";